import React from "react";

// Component to render lines using a given element type
const RenderLines = ({ lines, Component }) => (
  <>
    {lines.map((line, idx) => (
      <Component key={idx}>{line}</Component>
    ))}
  </>
);

const StageDetails = ({ stage }) => (
  <div>
    <div className="stages-title">{stage.title}</div>
    <div className="stage-desc valley-desktop">
      <RenderLines lines={stage.desc} Component="div" />
    </div>
    <div className="stage-desc valley-mobile">
      <RenderLines lines={stage.desc} Component="span" />
    </div>
  </div>
);

export default StageDetails;
